import axios from 'axios';
import { logger } from '#utils';
import { UserProfile } from '#types';
import { Routes } from '#config/routes';

export const api = {
  getUserDetails() {
    return axios.get('/api/user', {
      headers: { 'Content-Type': 'application/ld+json' },
    });
  },

  disableParentalControl() {
    return axios.get('/api/user/disable-parental-control', {
      headers: { 'Content-Type': 'application/ld+json' },
    });
  },

  resetParentalControl() {
    return axios.get('/api/user/reset-parental-control', {
      headers: { 'Content-Type': 'application/ld+json' },
    });
  },

  createProfile(profile: Pick<UserProfile, 'name' | 'avatarAssetId'>) {
    return axios({
      method: 'POST',
      url: '/api/user/profile',
      headers: { 'Content-Type': 'application/ld+json' },
      data: {
        profileData: {
          ...profile,
          clubMembershipId: 0,
        },
      },
    }).catch((error) => {
      logger.error('Error on profile create', {
        error,
      });
    });
  },

  updateProfile(data: Pick<UserProfile, 'id' | 'name' | 'avatarAssetId'>) {
    const { id, ...profileData } = data;

    return axios({
      method: 'PATCH',
      url: '/api/user/profile',
      headers: { 'Content-Type': 'application/ld+json' },
      data: {
        profileId: id,
        profileData,
      },
    }).catch((error) => {
      logger.error('Error on profile update', {
        error,
      });
    });
  },

  deleteProfile(id: number) {
    return axios({
      method: 'DELETE',
      url: '/api/user/profile',
      headers: { 'Content-Type': 'application/ld+json' },
      data: {
        profileId: id,
      },
    }).catch((error) => {
      logger.error('Error on profile delete', {
        id,
        error,
      });
    });
  },

  logout() {
    return axios.get(Routes.LOGOUT_CIDAAS);
  },
};
